import { Button, Grid } from '@mui/material';
import React from 'react';
import { useStoreDispatch } from '../../../store/hooks';
import { setBasicDialogOpenFor } from '../../../store/helpers/helperReducers';
import { ISelectedTemplate } from '../../../store/api/devices/types';
import { selectedTypeSelector } from '../../../store/api/devices/selectors';
import { useSelector } from 'react-redux';
import { useTemplateDisplay } from './hooks';

interface ITemplatesProps {
    selectedRow: ISelectedTemplate
};

const FileApply: React.FC<ITemplatesProps> = ({ selectedRow }) => {
    const { handleApplyTemplate } = useTemplateDisplay();
    const dispatch = useStoreDispatch();
    const selectedTempType = useSelector(selectedTypeSelector);
    // const [selectedTemplate, setSelectedTemplate] = useState<any>(null);

    const handleSelectedTemplate = () => {
        handleApplyTemplate(selectedRow, selectedTempType);
        dispatch(setBasicDialogOpenFor(undefined));
        //create dispatch to handle selected template
    }

    return (
        <Grid>
            <Button onClick={handleSelectedTemplate} sx={{ fontWeight: 200 }} variant="contained" color="primary">Select</Button>
        </Grid>
    );
}

export default FileApply;